import React, { type ComponentProps } from 'react';
import { defineMessages, useIntl, type MessageValue } from 'react-intl';

import { type AddressType, capitalizeFirstLetter } from '@sg/garnish';

import { BagHeaderLink } from '../BagHeaderLink';

/**
 * Channel selector for the bag header.
 */
export const BagChannelHeader = (props: BagChannelHeaderProps) => {
  const {
    orderChannel,
    accessibilityRole,
    isDisabled,
    nonFocusable,
    requestChannelOrLocationChange,
  } = props;

  const { formatMessage } = useIntl();
  const accessibilityLabel = formatMessage(messages.accessibilityLabel, {
    channel: orderChannel,
  });

  return (
    <BagHeaderLink
      accessibilityLabel={accessibilityLabel}
      accessibilityRole={accessibilityRole}
      isDisabled={isDisabled}
      nonFocusable={nonFocusable}
      onPress={requestChannelOrLocationChange}
    >
      {capitalizeFirstLetter(orderChannel)}
    </BagHeaderLink>
  );
};

// ─── Messages ───────────────────────────────────────────────────────────────

const messages = defineMessages<{
  readonly accessibilityLabel: { readonly channel: MessageValue };
}>({
  accessibilityLabel: {
    defaultMessage: 'Change channel: {channel}',
    description: 'Bag | Header | Change channel',
  },
});

// ─── Types ──────────────────────────────────────────────────────────────────

type BagChannelHeaderProps = {
  isDisabled?: boolean;
  nonFocusable?: boolean;
  accessibilityRole?: ComponentProps<typeof BagHeaderLink>['accessibilityRole'];
  orderChannel: AddressType;
  requestChannelOrLocationChange: () => void;
};
